import type { GameEvent } from '../schema';
import { CAREER_EVENTS } from './career';
import { EDUCATION_EVENTS } from './education';
import { FINANCE_EVENTS } from './finance';
import { INVESTMENT_EVENTS } from './investment';
import { BUSINESS_EVENTS } from './business';
import { ROMANCE_EVENTS } from './romance';
import { FAMILY_EVENTS } from './family';
import { HEALTH_EVENTS } from './health';
import { WELLBEING_EVENTS } from './wellbeing';
import { SOCIAL_EVENTS } from './social';
import { CRISIS_EVENTS, INERTIA_EVENTS, OPPORTUNITY_EVENTS } from './crisis';
import { MILESTONE_EVENTS, RETIREMENT_EVENTS } from './milestones';
import { LIFE_EVENTS } from './life';
import { EXPANSION_EVENTS } from './expansion';

export const ALL_EVENTS: readonly GameEvent[] = [
  ...CAREER_EVENTS,
  ...EDUCATION_EVENTS,
  ...FINANCE_EVENTS,
  ...INVESTMENT_EVENTS,
  ...BUSINESS_EVENTS,
  ...ROMANCE_EVENTS,
  ...FAMILY_EVENTS,
  ...HEALTH_EVENTS,
  ...WELLBEING_EVENTS,
  ...SOCIAL_EVENTS,
  ...CRISIS_EVENTS,
  ...OPPORTUNITY_EVENTS,
  ...INERTIA_EVENTS,
  ...MILESTONE_EVENTS,
  ...RETIREMENT_EVENTS,
  ...LIFE_EVENTS,
  ...EXPANSION_EVENTS,
];

export const EVENTS_BY_ID: Record<string, GameEvent> = Object.fromEntries(
  ALL_EVENTS.map((e) => [e.id, e]),
);

/** Pool name → events, built once at module load. */
export const EVENTS_BY_POOL: Record<string, GameEvent[]> = (() => {
  const map: Record<string, GameEvent[]> = {};
  for (const event of ALL_EVENTS) {
    for (const pool of event.pools) {
      (map[pool] ??= []).push(event);
    }
  }
  return map;
})();
